<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-button type="primary" plain @click="goHxList"
          >人格画像设置
          </el-button
          >
          <el-button type="danger" plain @click="goBack"
          >返回题目
          </el-button
          >
        </div>
      </div>
    </div>
    <div class="topic-outer" style="padding-top: 20px">
      <el-tabs v-model="activeNames" @tab-click="handleTabClick">
        <el-tab-pane v-if="index != 0" v-for="(item,index) in getWDData" :key="index" :label="item.name"
                     :name="item.code"></el-tab-pane>
      </el-tabs>
      <div v-if="getJZData && getJZData.length">
        <el-tabs
            tab-position="left"
            v-model="activeName"
            @tab-click="handleJzClick"
        >
          <el-tab-pane
              v-for="item in getJZData"
              :key="item.examResultId"
              :label="item.name"
              :name="item.code"
          >
          </el-tab-pane>
          <div style="margin-left: 20px">
            <div class="public-dialog-form" style="width: 800px">
              <div class="item_info_tabs">子维度得分最高结果设置</div>
              <el-form
                  ref="ruleForm"
                  :rules="rules"
                  :model="params"
                  label-width="85px"
              >
                <el-form-item label="说明" prop="name">
                  <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
                </el-form-item>
                <el-divider><span style="font-size: 18px;font-weight: bold">本我的力量</span></el-divider>
                <el-form-item label="积极力量" prop="content">
                  <rich-text v-if="innerVisible" :keyWord="'descr'" :params="params?params:''"></rich-text>
                </el-form-item>
                <el-form-item label="消极影响" prop="content">
                  <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
                </el-form-item>
                <el-divider style="font-size: 18px;font-weight: bold"><span style="font-size: 18px;font-weight: bold">本我欲望的满足</span>
                </el-divider>
                <el-form-item label="建议标题" prop="name">
                  <el-input v-model="params.title" style="width: 260px" placeholder="请输入建议标题"></el-input>
                </el-form-item>
                <el-form-item label="建议内容" prop="content">
                  <rich-text v-if="innerVisible" :keyWord="'guideSuggest'" :params="params?params:''"></rich-text>
                </el-form-item>
              </el-form>
              <div style="margin-bottom: 20px">
                <el-button type="primary" @click="handleEdit">保存设置</el-button>
              </div>
            </div>
            <div class="public-dialog-form">
              <div class="item_info_tabs">子维度分数区间设置</div>
              <div v-for="(item,index) in qjList" :key="index" style="margin-bottom: 20px">
                <div class="item_contents">
                  <div>
                    <div class="input_item">
                      <div class="name">分数区间：</div>
                      <div>
                        <el-input style="width: 260px" v-model="item.minScore" type="number"
                                  placeholder="请输入最小分值（大于等于）"></el-input>
                        -
                        <el-input v-model="item.maxScore" style="width: 260px" type="number"
                                  placeholder="请输入最大分值（小于等于）"></el-input>
                      </div>
                    </div>
                    <div class="input_item">
                      <div class="name">区间名称：</div>
                      <div>
                        <el-input v-model="item.title" style="width: 260px" placeholder="请输入名称"></el-input>
                      </div>
                    </div>
                    <div class="input_item">
                      <div class="name">区间解析：</div>
                      <el-input
                          style="width: 420px"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 4 }"
                          placeholder="请填写区间解析"
                          v-model="item.descr"
                      >
                      </el-input>
                    </div>
                  </div>
                  <div v-if="qjList.length>1" @click="removeQj(index,item)" class="remove_icon"><i
                      class="el-icon-delete"
                      style="color: #c7302f;font-size: 18px"></i>
                  </div>
                </div>
                <div>
                  <el-button @click="handQjEdit(index,item)" type="primary">保存设置</el-button>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <el-button type="primary" @click="addQj">添加分数区间</el-button>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import richText from "../../../components/richText";
export default {
  components: {
    richText,
  },
  data() {
    return {
      rules: {
        title: [
          {
            required: true,
            message: "请填写标题",
            trigger: "change",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {
        title: '提升建议'
      },
      activeNames: '',
      qjList: [
        {
          minScore: 0,
          maxScore: 0,
          title: '',
          descr: ''
        }
      ],
      getWDData: [],
      getJZData: [],
      innerVisible:false
    };
  },
  created() {
    this.getAppraisalData();
    this.getWDList();
  },
  methods: {
    handleTabClick() {
      this.getJZList(this.activeNames)
    },
    removeQj(e, item) {
      if (item.examResultId) {
        this.$confirm("确认删除数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$delete(
              "exam/result/info/"+item.examResultId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
          this.qjList.splice(e, 1)
        })
      }else {
        this.qjList.splice(e, 1)
      }
    },
    addQj() {
      let obj = {
        minScore: 0,
        maxScore: 0,
        title: '',
        descr: ''
      }
      this.qjList.push(obj)
    },

    handleJzClick() {
      this.innerVisible = false
      this.initJZ()
      this.initQjJZ()
    },

    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 获取测评基准列表
     */
    async getJZList(code) {
      this.getJZData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/datum/list`, {
        params: {
          examId: this.$route.query.examId,
          examDimensionCode: code,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) this.getJZData = resData.data;
      if (resData.data) {
        this.activeName = resData.data[0].code
        this.initJZ()
        this.initQjJZ()
      }
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) this.getWDData = resData.data;
      if (resData.data) {
        this.activeNames = resData.data[1].code
        this.getJZList(this.activeNames)
      }
    },
    /**
     * 获取题目答案
     */
    async initJZ() {
      this.loading = true;
      const {data: resData} = await this.$get(
          '/exam/result/list?examId=' + this.$route.query.examId + '&examDimensionCode=' + this.activeNames + "&examDatumCode=" + this.activeName
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.params = resData.data[0]
      } else {
        this.params = {title: '提升建议'}
      }
      this.innerVisible = true
    },

    async initQjJZ() {
      this.loading = true;
      const {data: resData} = await this.$get(
          '/exam/result/list?examId=' + this.$route.query.examId + '&examDimensionCode=' + this.activeNames + "&examDatumCode=" + this.activeName + '&resultType=rgtp'
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.qjList = resData.data
      } else {
        this.qjList = [
          {
            minScore: 0,
            maxScore: 0,
            title: '',
            descr: ''
          }
        ]
      }
    },

    handleEdit(type) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.examId = this.$route.query.examId
          this.params.examDimensionCode = this.activeNames
          this.params.examDatumCode = this.activeName
          if (this.params.examInfoId) {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
            this.initJZ()
          } else {
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
            this.initJZ()
          }
        })
      });
    },

    handQjEdit(index, item) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (item.examResultId) {
            let obj = {
              resultType: 'rgtp',
              examId: this.$route.query.examId,
              examDimensionCode: this.activeNames,
              examDatumCode: this.activeName,
              minScore: item.minScore,
              maxScore: item.maxScore,
              title: item.title,
              descr: item.descr,
              examResultId: item.examResultId
            }
            const {data: resData} = await this.$put(
                "exam/result/info",
                obj,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
            this.initQjJZ()
          } else {
            let obj = {
              resultType: 'rgtp',
              examId: this.$route.query.examId,
              examDimensionCode: this.activeNames,
              examDatumCode: this.activeName,
              minScore: item.minScore,
              maxScore: item.maxScore,
              title: item.title,
              descr: item.descr,
              examResultId: item.examResultId
            }
            const {data: resData} = await this.$post(
                "exam/result/info",
                obj,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
            this.initQjJZ()
          }
        })
      });
    },

    goHxList() {
      this.$router.push({
        name: "RGTPHX_SET",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}

.item_info_tabs {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  line-height: 20px;
  height: 26px !important;
}

.public-dialog-form .editor .ql-container.ql-snow {
  height: 220px;
  overflow-y: auto;
}
</style>